import script from "./report2Xh.vue?vue&type=script&setup=true&lang=js"
export * from "./report2Xh.vue?vue&type=script&setup=true&lang=js"

import "./report2Xh.vue?vue&type=style&index=0&id=b8758890&lang=less"

const __exports__ = script;

export default __exports__